/** 租户端布局的工作模式。 */
export enum WorkMode {
  BUSINESS = 'business',
  ADMIN = 'admin',
}
